// extracted by mini-css-extract-plugin
export default {"wrapper":"Language_wrapper__Cf-li","inputs":"Language_inputs__SptB-"};